import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ServiceConfigModel extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Step][getAll] organizationId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/service_config`;
    }
}
